// Shared organic-social metric schemas — used by both the manager-facing Insights page
// and the public, no-login view-only report page, so labels stay in sync.
export const IG_METRICS = [
  { key: 'followers', label: 'followers', unit: '' },
  { key: 'net_followers', label: 'net new', unit: '', hint: 'followers gained – lost' },
  { key: 'reach', label: 'reach', unit: '', hint: 'unique accounts reached' },
  { key: 'views', label: 'views', unit: '', hint: 'total content plays / impressions' },
  { key: 'profile_visits', label: 'profile visits', unit: '' },
  { key: 'link_clicks', label: 'link clicks', unit: '' },
  { key: 'engagement', label: 'engagement', unit: '', hint: 'likes + comments + saves + shares' },
  { key: 'engagement_rate', label: 'engagement rate', unit: '%', hint: 'engagement ÷ reach' },
  { key: 'story_reach', label: 'story reach', unit: '' },
  { key: 'reel_plays', label: 'reel plays', unit: '' },
  { key: 'posts_published', label: 'posts published', unit: '' },
  { key: 'stories_published', label: 'stories published', unit: '' },
];

export const TT_METRICS = [
  { key: 'followers', label: 'followers', unit: '' },
  { key: 'net_followers', label: 'net new', unit: '', hint: 'followers gained – lost' },
  { key: 'total_likes', label: 'total likes', unit: '', hint: 'cumulative account likes' },
  { key: 'video_views', label: 'video views', unit: '' },
  { key: 'profile_views', label: 'profile views', unit: '' },
  { key: 'engagement', label: 'engagement', unit: '', hint: 'likes + comments + shares' },
  { key: 'engagement_rate', label: 'engagement rate', unit: '%' },
  { key: 'avg_watch_time', label: 'avg watch time', unit: 's', hint: 'seconds per view' },
  { key: 'completion_rate', label: 'completion rate', unit: '%', hint: '% who watched to end' },
  { key: 'shares', label: 'shares', unit: '' },
  { key: 'videos_published', label: 'videos published', unit: '' },
  { key: 'live_hours', label: 'live hours', unit: 'h' },
];
